export const DashboardTranslationsDictionary =
{
    Messages: "Messages",
    Settings: "Settings",
    RoadsideCheck: "Roadside Check",
    Trips: "Trips",
    EmailHOSLogs: "Email HOS Logs",
    NoTripsToday: "No trips today",
    TripsToday: "{0} trips today",
    Vehicle: "Vehicle",
    Trailers: "Trailers",
    DriverSafety: "Driver Safety",
    AssetInspection: "Asset Inspection",
    Inspections: "Inspections",
    HOSStatus: "HOS Status",
    HOSLimit: "HOS Limit",
    None: "None",
    NA: "N/A",
    Shipment: "Shipment",
    Shipments: "Shipments",
    Disabled: "Disabled",
    NoVehicle: "No vehicle",
    NewInspection: "New inspection",
    NeedsReview: "Needs Review",
    NotAvailable: "Not available",
    Addin: "Add In",
    Coaching: "Coaching",
    Feedback: "Give us feedback",
    NoUnread: "No Unread"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in DashboardTranslationsDictionary) {
        r.push(DashboardTranslationsDictionary[prop]);
    }
    return r;
};

export const DashboardTranslations = getTranslations();